import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CertificateTypeForm from '../../../components/forms/CertificateTypeForm';
import { useCertificateTypeApi } from '../../../hooks/useCertificateTypeApi';
import { useNavigate } from 'react-router-dom';
import { CertificateTypeDTO } from '../../../services/apiClient';

const CertificateTypeCreate: React.FC = () => {
  const { create, isLoading } = useCertificateTypeApi();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Certificate Types', href: '/admin/certificatetypes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: CertificateTypeDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate('/admin/certificatetypes');
    } catch (error) {
      console.error('Error creating CertificateType:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/certificatetypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.CertificateType.Edit"
    >
      <CertificateTypeForm
        initialValues={{} as CertificateTypeDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/admin/certificatetypes')}
        isLoading={isSubmitting}
      />
    </AdminLayout>
  );
};

export default CertificateTypeCreate;
